import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DocumentConstants } from '@uzurv/core';
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import moment from 'moment-timezone';
import { Document } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class DocumentService extends UzurvRestService {
  private readonly resourceUrl = 'documents/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  isDocumentExpiring(document: Document): boolean {
    if (document.expirationDate == null) {
      return false;
    }

    return moment(document.expirationDate).isBetween(moment(), moment().add(DocumentConstants.DAYS_BEFORE_EXPIRATION_TO_FLAG, 'days'));
  }

  isDocumentExpired(document: Document): boolean {
    if (document.expirationDate == null) {
      return false;
    }
    return moment(document.expirationDate) <= moment();
  }

  protected getApiUrl(): string {
    return this.uzurvRestConfiguration.dotsApiUrl;
  }
}
